/**
 * 【KYMW1400】コマIDVO
 *
 * @export KomaIDModel
 * @class KomaIDModel
 */
export class KomaIDModel {
  /**
   *  コマID
   */
  public komaID = Number(0);

  /**
   *  注文商品区分
   */
  public orderGoodsFlg = String('');

  /**
   *  媒体区分
   */
  public mediumType = String('');
}
